import cx from "classnames";
import { FC, SVGProps } from "react";
import { Link } from "react-router-dom";

import { Icon } from "atoms/icon/Icon";
import ChevronRight from "atoms/icon/icons/ic_chevron_right_small_ol.svg";

export interface SettingsContainerProps {
  children: string;
  disabled?: boolean;
  onClick?: () => void;
  to?: string;
  startIconSVG?: FC<SVGProps<SVGSVGElement>>;
}

export const SettingsContainer = ({
  children,
  disabled = false,
  to,
  onClick,
  startIconSVG: Svg,
}: SettingsContainerProps) => {
  return (
    <div className={cx({ "pointer-events-none opacity-40": disabled })}>
      <Link to={to ?? ""} className={!disabled ? "cursor-pointer" : ""}>
        <button
          disabled={disabled}
          className="flex w-full items-center gap-4 bg-white p-4 text-left text-body1 text-primary transition-opacity active:opacity-60"
          onClick={onClick}
        >
          {Svg && <Svg className="h-6 w-6 fill-[theme(textColor.secondary)]" />}
          <div className="flex-1">
            {children.charAt(0).toUpperCase() + children.slice(1).toLowerCase()}
          </div>
          <div>
            <Icon svg={ChevronRight} color="brandColor" size="xsmall" />
          </div>
        </button>
      </Link>
    </div>
  );
};
